/**
 * Обзор платформы.
 *
 * Первым экраном — не красивые итоги, а то, что требует решения: сколько
 * отзывов ждёт модерации, сколько брендов заблокировано, что происходило
 * последним. Цифры кликабельны и ведут туда, где с ними можно что-то сделать.
 */
import { Card, Empty, Skeleton, fmtDateTime, num } from '@allswipes/ui';
import { Link } from 'react-router-dom';

import { api } from '../api';
import { Layout, ReadOnlyNote } from '../components/Layout';
import { useResource } from '../hooks';

export function OverviewScreen() {
  const data = useResource(() => api.adminOverview(), []);

  return (
    <Layout title="Обзор" subtitle="что на платформе происходит прямо сейчас">
      <ReadOnlyNote />

      {data.loading && <Skeleton count={2} height={90} />}
      {data.error && <Empty icon="alert" title="Не загрузилось">{data.error}</Empty>}

      {data.data && (
        <>
          <div className="stats" style={{ marginBottom: 18 }}>
            <Stat to="/brands" value={data.data.brands} label="брендов" />
            <Stat to="/campaigns" value={data.data.active} label="акций идёт" />
            <Stat to="/campaigns" value={data.data.campaigns} label="всего акций" />
            <Stat to="/reviews" value={data.data.reviews} label="отзывов" />
            <Stat to="/reviews?only=hidden" value={data.data.hidden_reviews} label="скрыто" />
            <Stat to="/reviews" value={data.data.low_rated} label="оценок 1–2 ★" />
            <Stat to="/settings" value={data.data.subscribers} label="подписок на новости" />
          </div>

          {data.data.blocked_brands > 0 && (
            <div className="note" style={{ marginBottom: 18 }}>
              <span>
                Заблокировано брендов: {num(data.data.blocked_brands)}. Их акции остаются в базе —
                у участников на руках билеты, и стирать их доказательства нельзя.
              </span>
            </div>
          )}

          <div className="fgrid">
            <Card>
              <div className="h2" style={{ marginBottom: 10 }}>
                Последние действия
              </div>
              {data.data.recent_audit.length === 0 ? (
                <Empty title="Журнал пуст" />
              ) : (
                data.data.recent_audit.slice(0, 10).map((entry) => (
                  <div className="krow" key={entry.id}>
                    <span className="k">
                      {entry.action}
                      <span className="faint" style={{ display: 'block', fontSize: 11 }}>
                        {entry.actor || '—'}
                      </span>
                    </span>
                    <span className="v faint" style={{ fontSize: 11.5 }}>
                      {fmtDateTime(entry.created_at)}
                    </span>
                  </div>
                ))
              )}
              <div style={{ marginTop: 12 }}>
                <Link to="/audit" className="btn out sm">
                  Весь журнал
                </Link>
              </div>
            </Card>

            <Card>
              <div className="h2" style={{ marginBottom: 10 }}>
                Свежие акции
              </div>
              {data.data.recent_campaigns.length === 0 ? (
                <Empty title="Акций пока нет" />
              ) : (
                data.data.recent_campaigns.map((c) => (
                  <div className="krow" key={c.id}>
                    <span className="k">
                      {c.name}
                      <span className="faint" style={{ display: 'block', fontSize: 11 }}>
                        {c.recipe} · {c.status}
                      </span>
                    </span>
                    <span className="v faint" style={{ fontSize: 11.5 }}>
                      {num(c.participants)} уч.
                    </span>
                  </div>
                ))
              )}
              <div style={{ marginTop: 12 }}>
                <Link to="/campaigns" className="btn out sm">
                  Все акции
                </Link>
              </div>
            </Card>
          </div>
        </>
      )}
    </Layout>
  );
}

function Stat({ to, value, label }: { to: string; value: number; label: string }) {
  return (
    <Link to={to} className="stat">
      <div className="v">{num(value)}</div>
      <div className="l">{label}</div>
    </Link>
  );
}
